export default __webpack_public_path__ + "static/media/banner-img-two.7874bc3e.png";